/**
 * Explicit Phaser container / object depth order.
 * Lower draws first. Keep magic numbers out of PlayingScene.
 */
export const RENDER_LAYERS = {
  backdrop: -10,
  terrain: 0,
  pathDecoration: 10,
  boardEdge: 15,
  placementPreview: 20,
  towers: 30,
  towerRange: 25,
  enemies: 40,
  projectiles: 50,
  status: 55,
  combatFx: 60,
  selection: 70,
  markers: 80,
  debugOverlay: 90,
  uiChrome: 100
} as const

export type RenderLayerId = keyof typeof RENDER_LAYERS
